import React, { FunctionComponent } from 'react';
import { WPAcfRecruitmentSteps } from 'types/acf/recruitment';
import { Fragment } from 'react';
import Description from '../Description/Description';
import { Block, BlockContent, BlockHeader } from 'components/elements';
import styles from './RecruitmentSteps.module.scss';

interface OwnProps {
  data: WPAcfRecruitmentSteps | null;
}

type RecruitmentStepsProps = JSX.IntrinsicElements['div'] & OwnProps;

const RecruitmentSteps: FunctionComponent<RecruitmentStepsProps> = props => {
  const { data } = props;

  if (!data) {
    return null;
  }

  const { steps = [], header } = data;

  return (
    <Fragment>
      {header && (
        <Block id="recruitment-steps" theme="dark" data-module="recruitment-steps">
          <BlockContent>
            <BlockHeader className={styles.header}>{header}</BlockHeader>
          </BlockContent>
        </Block>
      )}
      {steps &&
        steps.map((item, index) => {
          const { title, description, formId } = item;

          if (!title && !description && !formId) {
            return null;
          }

          return (
            <>
              {(description || title || formId) && (
                <Description
                  styled={true}
                  align="left"
                  key={`recruitment-step-${index}`}
                  theme="white"
                  data={{
                    description,
                    header: title,
                  }}
                  formId={formId}
                />
              )}
            </>
          );
        })}
    </Fragment>
  );
};

export default RecruitmentSteps;
